import { InferenceType, Capability as CapabilityMap } from "@/lib/playground-utils";

export const Capability = CapabilityMap;
export type Capability = import("@/lib/playground-utils").Capability;
export const Segment: Capability = Capability.PointSegment;

export interface PromptProps {
  uploadedImage: string | null;
  imageFile: File | null;
  setInferences: React.Dispatch<React.SetStateAction<InferenceType[]>>;
  inferenceUrl: string;
  variant?: string;
  initialPrompt?: string | null;
  initialSkill?: string | null;
  // Used only by Segment
  enablePointSegment?: boolean;
}
